// extracted by mini-css-extract-plugin
export var navbar = "nav-bar-module--navbar--Ofv0Y";
export var navLinks = "nav-bar-module--nav-links--AaV-E";
export var logo = "nav-bar-module--logo--3ETN7";
export var menu = "nav-bar-module--menu--2Hf3U";
export var hamburger = "nav-bar-module--hamburger--2w81D";
export var hamburger__bar = "nav-bar-module--hamburger__bar--1uT-p";
export var animate = "nav-bar-module--animate--2DyWe";
export var azure = "nav-bar-module--azure--CdsjO";
export var bgAzure = "nav-bar-module--bg-azure--1JVmr";
export var shown = "nav-bar-module--shown--1KJJl";
export var visuallyshown = "nav-bar-module--visuallyshown--2d6DP";
export var hidden = "nav-bar-module--hidden--iuZq5";
export var dropdown = "nav-bar-module--dropdown--1_eTC";